const currentDate = new Date();

export const todaysDate = new Date();
todaysDate.setUTCHours(0, 0, 0, 0);

export const aWeegAgo = new Date();
aWeegAgo.setDate(currentDate.getDate() - 5);
aWeegAgo.setHours(0, 0, 0, 0);

export const oneMonthAgoDate = new Date();
oneMonthAgoDate.setMonth(currentDate.getMonth() - 1);

const thirtyDaysAgoDate = new Date();
thirtyDaysAgoDate.setDate(thirtyDaysAgoDate.getDate() - 29);
thirtyDaysAgoDate.setHours(0, 0, 0, 0);

export { thirtyDaysAgoDate };

export const oneYearAgoDate = new Date();
oneYearAgoDate.setFullYear(currentDate.getFullYear() - 1);

export const threeYearAgoDate = new Date();
threeYearAgoDate.setFullYear(currentDate.getFullYear() - 3);

export const firstDate = new Date(1970, 0, 1);
